// import { InputSelect } from "#common/componentes/Inputs"
import { MasterDialog } from "#common/Dialog/Dialog"
import { useApi } from "#hooks/useApi"
import { useApiSend } from "#hooks/useApiSend"
import { jobProfileSkillPost, jobProfileSkillTypeGet } from "#job-profile/services/api"
import { Box, Button, Divider, Stack } from "@mui/material"
import TextField from "@mui/material/TextField"
import { useCallback, useMemo, useState } from "react"
import { toast } from "react-toastify"
import { JobProfileSkillsTable } from "./JobProfileSkillsTable"
import InputSelect from "#core/components/input/select/InputSelect"

const skillDefault = {
	name: "",
	type: "",
}

export default function JobProfileSkillsForm({ value, setValue }) {
	const { data, loading } = useApi(jobProfileSkillTypeGet, { autoFetch: true })

	return (
		<Stack spacing={2}>
			<InputSelect
				options={data?.data || []}
				label="Tipo"
				optionsId="id"
				optionsLabel="name"
				value={value.type}
				onChange={(e) =>
					setValue({
						...value,
						type: e.target.value,
						type_name: data?.data?.find((item) => item.id === e.target.value)?.name,
					})
				}
				loading={loading}
			/>
			<TextField
				label="Nombre"
				value={value.name}
				onChange={(e) => setValue({ ...value, name: e.target.value })}
			/>
		</Stack>
	)
}

export const jobProfileSkillsFormValidate = (skill) => {
	if (!skill.name) {
		toast.error("El nombre es requerido", { toastId: "invalidSkillName" })
		return
	}
	if (!skill.type) {
		toast.error("El tipo es requerido", { toastId: "invalidSkillType" })
		return
	}
	return true
}

export const JobProfileSkillsFormDialog = ({ open, setOpen, profileId, refresh }) => {
	const [skill, setSkill] = useState(skillDefault)
	const [disabled, setDisabled] = useState(false)
	const success = () => {
		setOpen(false)
		setSkill(skillDefault)
		refresh()
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(jobProfileSkillPost, { success, end })

	const handleSend = useCallback(() => {
		if (!jobProfileSkillsFormValidate(skill)) return
		setDisabled(true)
		fetch(profileId, skill)
	}, [fetch, profileId, skill])

	const handleClose = useCallback(() => {
		setOpen(false)
		setSkill(skillDefault)
	}, [setOpen])

	const buttons = useMemo(
		() => [
			{
				label: "Cancelar",
				onClick: handleClose,
				disabled,
			},
			{
				label: "Agregar",
				onClick: handleSend,
				disabled,
			},
		],
		[disabled, handleClose, handleSend]
	)

	return (
		<MasterDialog
			{...{
				open,
				setOpen,
				title: "Agregar capacidades profesionales",
				buttons,
				maxWidth: "md",
				closeDialog: handleClose,
			}}
		>
			<JobProfileSkillsForm value={skill} setValue={setSkill} />
		</MasterDialog>
	)
}

export const JobProfileSkillsFormList = ({ value, setValue }) => {
	const [skill, setSkill] = useState(skillDefault)

	const handleSave = () => {
		if (!jobProfileSkillsFormValidate(skill)) return
		if (
			value.find((item) => {
				return item.name.toLowerCase().trim() === skill.name.toLowerCase().trim()
			})
		) {
			toast.error("Ya existe una capacidades profesionales con ese nombre")
			return
		}
		setValue((old) => [...old, skill])
		setSkill(skillDefault)
	}
	const handleDelete = useCallback(
		(datum) => {
			setValue(value.filter((item) => item.name !== datum.name))
		},
		[setValue, value]
	)
	const valueOrdered = value?.sort((a, b) => a.type_name.localeCompare(b.type_name))
	return (
		<Box display={"flex"} flexDirection={"column"} gap={2} width={"100%"}>
			<JobProfileSkillsForm value={skill} setValue={setSkill} />
			<Box display={"flex"} flexDirection={"column"} gap={1} alignItems={"center"}>
				<Button onClick={handleSave}>Agregar</Button>
			</Box>
			<Divider sx={{ width: "100%" }} />
			<Box
				display={"flex"}
				gap={2}
				alignContent={"center"}
				flexWrap="wrap"
				flexDirection={{ xs: "column", sm: "row" }}
			>
				<JobProfileSkillsTable data={valueOrdered} onDelete={handleDelete} />
			</Box>
		</Box>
	)
}
